import { render, staticRenderFns } from "./CardLogos.vue?vue&type=template&id=2de34050&"
import script from "./CardLogos.vue?vue&type=script&lang=js&"
export * from "./CardLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports